var installedModules = {};
var moduleToHandlerMapping = {
	63049: {
		getter: () => (__webpack_require__.e(482).then(() => (() => (__webpack_require__(22482))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	60435: {
		getter: () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(761)]).then(() => (() => (__webpack_require__(29761))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/core",
	},
	34001: {
		getter: () => (__webpack_require__.e(482).then(() => (() => (__webpack_require__(22482))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	83571: {
		getter: () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(5774))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	90809: {
		getter: () => (Promise.all([__webpack_require__.e(140), __webpack_require__.e(571), __webpack_require__.e(574)]).then(() => (() => (__webpack_require__(76574))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.3.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	2584: {
		getter: () => (__webpack_require__.e(229).then(() => (() => (__webpack_require__(64229))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">=1.x",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	15942: {
		getter: () => (__webpack_require__.e(229).then(() => (() => (__webpack_require__(64229))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">= 1.x",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	28371: {
		getter: () => (__webpack_require__.e(607).then(() => (() => (__webpack_require__(13607))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	1946: {
		getter: () => (Promise.all([__webpack_require__.e(571), __webpack_require__.e(397)]).then(() => (() => (__webpack_require__(39397))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech/ui-icons",
	},
	19442: {
		getter: () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(49), __webpack_require__.e(127)]).then(() => (() => (__webpack_require__(27127))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	},
	23499: {
		getter: () => (Promise.all([__webpack_require__.e(227), __webpack_require__.e(1)]).then(() => (() => (__webpack_require__(27227))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.97.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/dev-tools-utils",
	},
	77804: {
		getter: () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(49), __webpack_require__.e(127)]).then(() => (() => (__webpack_require__(27127))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@vk-tech-solar/config",
	},
	85587: {
		getter: () => (__webpack_require__.e(557).then(() => (() => (__webpack_require__(91557))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"1": [
		34001
	],
	"49": [
		63049
	],
	"401": [
		19442,
		23499,
		77804,
		85587
	],
	"435": [
		60435
	],
	"568": [
		2584,
		15942,
		28371
	],
	"571": [
		83571
	],
	"809": [
		90809
	],
	"946": [
		1946
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}